import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function TCanalcli() {
    const [canales, setCanales] = useState([]);
    const [canalesFiltrados, setCanalesFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idCanal: '',
        nomCanal: ''
    });
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/canalescliente';

    useEffect(() => {
        cargarCanales();
    }, []);

    useEffect(() => {
        filtrarCanales();
    }, [busqueda, canales]);

    const cargarCanales = async () => {
        try {
            const response = await axios.get(API_URL);
            setCanales(response.data);
            setCanalesFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar canales de cliente:', error);
            alert('Error al cargar los canales de cliente');
        }
    };

    const filtrarCanales = () => {
        if (!busqueda) {
            setCanalesFiltrados(canales);
            setPaginaActual(1);
            return;
        }

        const filtrados = canales.filter(canal =>
            canal.idCanal?.toString().includes(busqueda) ||
            canal.nomCanal?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setCanalesFiltrados(filtrados);
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idCanal: '',
            nomCanal: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (canal) => {
        setFormulario({
            idCanal: canal.idCanal,
            nomCanal: canal.nomCanal
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idCanal: '',
            nomCanal: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomCanal.trim()) {
            alert('El nombre del canal es requerido');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idCanal}`, formulario);
                alert('Canal de cliente actualizado exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('Canal de cliente creado exitosamente');
            }
            cargarCanales();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el canal de cliente');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este canal de cliente?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Canal de cliente eliminado exitosamente');
                cargarCanales();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el canal de cliente');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = canalesFiltrados.map(canal => ({
            'ID': canal.idCanal,
            'Nombre': canal.nomCanal
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Canales de Cliente');
        XLSX.writeFile(workbook, 'canales_cliente.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const canalesActuales = canalesFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(canalesFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Canales de Cliente</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Canal
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre del Canal</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {canalesActuales.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay canales de cliente para mostrar</td>
                            </tr>
                        ) : (
                            canalesActuales.map(canal => (
                                <tr key={canal.idCanal}>
                                    <td>{canal.idCanal}</td>
                                    <td>{canal.nomCanal}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(canal)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(canal.idCanal)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, canalesFiltrados.length)} de {canalesFiltrados.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Canal de Cliente' : 'Nuevo Canal de Cliente'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre del Canal *</label>
                                <input
                                    type="text"
                                    value={formulario.nomCanal}
                                    onChange={(e) => setFormulario({ ...formulario, nomCanal: e.target.value })}
                                    required
                                    maxLength={15}
                                    placeholder="Ingrese el nombre del canal"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TCanalcli;
